export const GREEN_COLOR_JS = '#198754'
export const YELLOW_BACKGROUND_JS = '#FFF8BA'
export const WHITE_BACKGROUND_JS = '#FFF'
export const INVALID_FEEDBACK_COLOR = '#DC3545'

export const ORANGE_COLOR_PASSPORT = '#EA7306'

export const BLUE_COLOR_SELECTION = '#0D6EFD'

export const INVALID_CLASS_SELECT = 'reactselect-invalid__control'